type QueryParamValue = string | number | boolean | null | undefined;

const normalizeBaseUrl = (baseUrl: string) => baseUrl.replace(/\/+$/, "");
const normalizePath = (path: string) => path.replace(/^\/+/, "");

export const buildUrl = (
  baseUrl: string,
  path: string,
  params: Record<string, QueryParamValue> = {}
) => {
  const url = new URL(`${normalizeBaseUrl(baseUrl)}/${normalizePath(path)}`);
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    searchParams.set(key, String(value));
  });

  const serialized = searchParams.toString();
  if (serialized) url.search = serialized;
  return url.toString();
};

export type { QueryParamValue };
